import type { TFunction } from "i18next";
import { CircleCheckBigIcon, CircleIcon, MoonIcon } from "lucide-react";

import { SupportTicketStatus } from "~/graphql/graphql.gen";

export const TodoIcon = CircleIcon;
export const SnoozedIcon = MoonIcon;
export const DoneIcon = CircleCheckBigIcon;

export const getStatuses = (t: TFunction) => [
  {
    value: SupportTicketStatus.Todo,
    label: t("ticket.status.todo"),
    color: "var(--color-todo)",
    icon: TodoIcon,
  },
  {
    value: SupportTicketStatus.Snoozed,
    label: t("ticket.status.snoozed"),
    color: "var(--color-snoozed)",
    icon: SnoozedIcon,
  },
  {
    value: SupportTicketStatus.Done,
    label: t("ticket.status.done"),
    color: "var(--color-done)",
    icon: DoneIcon,
  },
];

export const sortStatus = (a: SupportTicketStatus, b: SupportTicketStatus) => {
  const map = new Map<string, number>();
  map.set(SupportTicketStatus.Todo, 0);
  map.set(SupportTicketStatus.Snoozed, 1);
  map.set(SupportTicketStatus.Done, 2);

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  if (map.get(a)! < map.get(b)!) {
    return -1;
  }
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  if (map.get(a)! > map.get(b)!) {
    return 1;
  }
  return 0;
};
